import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'auth/auth.service';

export const routes: Routes = [
    {
        path: 'blog',
        loadChildren: () =>
          import('../blog/blog.module').then((m) => m.BlogModule),
    },
    { 
        path: 'category/:categoryName', 
        loadChildren: () =>
            import('../blog/blog.module').then((m) => m.BlogModule),
    },
    {
        path: 'call',
        loadChildren: () => import('../call/call.module').then(m => m.CallModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'account',
        loadChildren: () => import('../account/account.module').then(m => m.AccountModule),
        canActivate: [AuthGuard],
    },
    {
        path: '',
        loadChildren: () => import('../landing/landing.module').then(m => m.LandingModule),
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: false })],
    exports: [RouterModule],
})
export class AppRoutingModule {
}